<template>
    <div class="image-slider">
        <div class="image-prev" @click="prev()">
            <icons icon="chevron-left"></icons>
        </div>
        <v-touch @swipeleft="next()" @swiperight="prev()">
            <div class="image-container"
                 :style="{'margin-left': currentOffset + 'px', 'max-width': width+'px'}">
                <img v-for="image in images" :src="image">
            </div>
        </v-touch>
        <div class="image-next" @click="next()">
            <icons icon="chevron-right"></icons>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ImageSlider',
        props: ['images'],
        data: () => ({
            elements: [],
            current: 0,
            width: 0,
            changeRate: 2000,
            changeInterval: 0,
            resetTimeout: 0,
        }),
        computed: {
            currentOffset() {
                let offset = 0;
                for (let x = 0; x < this.current; x++) {
                    offset += this.elements[x].clientWidth
                }
                return -offset
            }
        },
        mounted() {
            this.getSizing()
            this.changeInterval = setInterval(() => {
                this.next();
            }, this.changeRate)
            window.addEventListener('resize', () => {
                setTimeout(() => {
                    this.getSizing();
                }, 250)
            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', () => {
                setTimeout(() => {
                    this.getSizing();
                }, 250)
            })
        },
        methods: {
            next(set = null) {
                clearInterval(this.changeInterval)
                clearTimeout(this.resetTimeout)
                if (set !== null) {
                    this.current = set
                } else {
                    if (this.current === (this.images.length - 1)) {
                        this.current = 0;
                    } else {
                        this.current++;
                    }
                }
                this.resetTimeout = setTimeout(() => {
                    this.changeInterval = setInterval(() => {
                        this.next();
                    }, this.changeRate)
                }, this.changeRate * 2)
            },
            prev(set = null) {
                clearInterval(this.changeInterval)
                clearTimeout(this.resetTimeout)
                if (set !== null) {
                    this.current = set
                } else {
                    if (this.current === 0) {
                        this.current = (this.images.length - 1);
                    } else {
                        this.current--;
                    }
                }
                this.resetTimeout = setTimeout(() => {
                    this.changeInterval = setInterval(() => {
                        this.next();
                    }, this.changeRate)
                }, this.changeRate * 2)
            },
            getSizing() {
                this.elements = this.$el.querySelectorAll('img');
                this.width    = this.$el.clientWidth
                this.$forceUpdate();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ImageSlider.vue?78be9252